import "./style.scss";
import { useSelector, useDispatch } from "react-redux";
import { onlineApplicationsHeaderSelectConst } from "@/src/constants/applicationOnlineConsts";
import SelectDefault from "../../SelectDefault/SelectDefault";
import BtnDefault from "../../BtnDefault/BtnDefault";
import Refresh from "@/src/svg/header/Refresh";
import Archiv from "@/src/svg/header/Archiv";
import AddNew from "@/src/svg/header/AddNew";
import { setActualOfficeTable, setFilterStatus } from "@/src/store/slices/ApplicationPage/applicationsFiltersSlice";
import { RootState } from "@/src/store";

const HeaderApplications = () => {
  const dispatch = useDispatch();
  const actualOfficeTable = useSelector((state: RootState) => state.applicationsFilters.actualOfficeTable);
  const hasFullCountryAccess = useSelector((state: RootState) => state.accessControl.hasFullCountryAccess);
  const isOfficeSelectDisabled = !hasFullCountryAccess;

  const handleChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (isOfficeSelectDisabled) return;
    dispatch(setActualOfficeTable(event.target.value));
    dispatch(setFilterStatus("All"));
  };

  const handleEventRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="header-applications">
      <div className={`header-bottom-select ${isOfficeSelectDisabled ? "disabled" : ""}`}>
        <SelectDefault
          onChange={handleChangeEvent}
          value={actualOfficeTable || "ALL"}
          disabled={isOfficeSelectDisabled}
        >
          {onlineApplicationsHeaderSelectConst.map((item) => (
            <option value={item.id} key={item.id}>
              {item.title}
            </option>
          ))}
        </SelectDefault>
      </div>
      <div className="header-bottom-buttons">
        <BtnDefault onClick={handleEventRefresh}>
          <p>Refresh</p>
          <Refresh />
        </BtnDefault>
        <BtnDefault>
          <p>Archiv</p>
          <Archiv />
        </BtnDefault>
        <BtnDefault
          reverse={true}
          onClick={() => {
            const current = localStorage.getItem("applyOnlineApplications");
            if (current === "show") {
              localStorage.removeItem("applyOnlineApplications");
            } else {
              localStorage.setItem("applyOnlineApplications", "show");
            }
            window.dispatchEvent(new Event("applyOnlineApplicationsChanged"));
          }}
        >
          <p>Add new</p>
          <AddNew />
        </BtnDefault>
      </div>
    </div>
  );
};

export default HeaderApplications;
